// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__p14dZ","alert__title":"Alert_alert__title__cSSZU","alert__description":"Alert_alert__description__PhEwn","alert__close":"Alert_alert__close__gdo9A"};